import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ConversationalForm from "@/pages/ConversationalForm";
import LandingPage from "@/components/LandingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/formulario" element={<ConversationalForm />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
